import Close from 'icons/close';

const CrossSellModalHeader = ({ onClose }: { onClose: () => void }) => (
  <div>
    <h2 id="profile-modal-title" className="text-center text-2xl font-bold uppercase">
      Thank you
    </h2>
    <div className="mx-auto mb-3 mt-4 h-[2px] w-[100px] border-b border-[#b19a6a]" role="separator"></div>
    <button className="absolute right-8 top-9 sm:top-12" type="button" onClick={onClose} aria-label="Close modal">
      <Close />
    </button>
  </div>
);

export default CrossSellModalHeader;
